//Add common values here

const SITE_URLS = {
  CANDIDATE_SITE_URL: 'https://app.connectedcrew.com.au',
  CENTRE_SITE_URL: 'https://my.connectedcrew.com.au',
  ADMIN_SITE_URL: 'https://admin.connectedcrew.com.au'
};

export const pathToUserType: Record<string, string> = {
  [SITE_URLS.ADMIN_SITE_URL]: 'Portal Admin',
  [SITE_URLS.CENTRE_SITE_URL]: 'Centre',
  [SITE_URLS.CANDIDATE_SITE_URL]: 'Candidate',
};

export const emailError = 'This email is already registered. Please use a different email.'

export const ExpiryAlertMsg = 'Expires in less than a month. Please ensure you renew then re-upload before expiry in order to search and accept jobs.';

export const secretKet = 'Y_Ca!qgYs16Cel;+YhvihtZAUS0'


// Common constants
export const ITEMS_PER_PAGE_OPTIONS = [10, 20, 50];
export const DEFAULT_ITEMS_PER_PAGE = 10;
export const MAX_VISIBLE_PAGES = 3;
export const DEFAULT_SEARCH_INPUT_LENGTH = 2;
export const DEFAULT_SEARCH_INPUT_DEBOUNCE_DELAY = 800 // debounce delay (ms)

export const JOB_LISTING_ITEMS_PER_PAGE_OPTIONS = [30, 60, 90];
export const JOB_LISTING_DEFAULT_ITEMS_PER_PAGE = 30;

// User roles
export const USER_ROLES = {
  CENTRE_ADMIN: 3,
  CENTRE_USER: 4,
};

// Error messages
export const ERROR_MESSAGES = {
  CONNECTION_ERROR: "Could not connect to services at the moment. Please try again. Thanks.",
  SELECTION_FAILED: "Selected candidate is not available at the moment. Please try with another candidate."
};

// Notification messages
export const NOTIFICATION_MESSAGES = {
  SAVE_SUCCESS: "Saved",
};

export const TFN_TEMPLATE_ID = "67996c42b0c59dd8438bd153";
export const TFN_FORM_ID = "b3e03291-42fe-445d-9de4-4c7204977a61";
export const TFN_CLIENT_ID = "fbc35805-d806-4c2d-8158-001765a6ac13";
export const TFN_NAME = "Tax File Number Declaration";


export const SUPER_FORM_TEMPLATE_ID = "685387f358516949cce35421";
export const SUPER_FORM_ID = "b3e03291-42fe-445d-9de4-4c7204977a61";
export const SUPER_FORM_CLIENT_ID = "fbc35805-d806-4c2d-8158-001765a6ac13";
export const SUPER_FORM_NAME = "Superannuation";

// export const CONTRACT_TEMPLATE_ID = "6883054aac73a5f1de1c49c9";
export const CONTRACT_TEMPLATE_ID = "68edb1a237c829f3e484d60b";

export const CANDIDATE_SORT_OPTIONS = [
  {value: "first_name-asc", label: "Employee Name", bold: "A - Z"},
  {value: "first_name-desc", label: "Employee Name", bold: "Z - A"},
  {value: "rating-desc", label: "Star Rating", bold: "Highest to Lowest"},
  {value: "past_jobs_count-desc", label: "Past Jobs at any Centre", bold: "Highest to Lowest"},
  {value: "last_job_date-desc", label: "Last Jobs at any Centre", bold: "Recent First"},
  {value: "preferred_accounts-desc", label: "Marked as Preferred on", bold: "Highest to Lowest"},
  {value: "decline_jobs_count-desc", label: "Declined", bold: "Highest to Lowest"},
];

export const COMPLIANCE_ALERTS_SORT_OPTIONS = [
  {value: "first_name-asc", label: "Employee Name", bold: "A - Z"},
  {value: "first_name-desc", label: "Employee Name", bold: "Z - A"},
  {value: "date_renewal-asc", label: "Date Renewal is Required by", bold: "Urgent First"},
  {value: "date_renewal-desc", label: "Date Renewal is Required by", bold: "Urgent Last"}
];

export const CENTRE_SORT_OPTIONS = [
  { value: "business_name-asc", label: "Centre Name - A - Z", bold: "A - Z" },
  { value: "business_name-desc", label: "Centre Name - Z - A", bold: "Z - A" },
  { value: "open_vacancies_count-desc", label: "Current Pending Vacancies", bold: "" },
];

export const USER_SORT_OPTIONS = [
  { value: "first_name-asc", label: "User Name - A - Z", bold: "A - Z" },
  { value: "first_name-desc", label: "User Name - Z - A", bold: "Z - A" },
  { value: "email-asc", label: "Email - A - Z", bold: "A - Z" },
  { value: "email-desc", label: "Email - Z - A", bold: "Z - A" },
];

export const STATUS_OPTIONS = [
  {value: "", label: "All", bold: "All"},
  {value: "active", label: "Active Only", bold: "Active Only"},
  {value: "inactive", label: "Inactive Only", bold: "Inactive Only"},
];

export const responseTimeframes = [
  { label: "15 mins", value: 15 },
  { label: "30 mins", value: 30 },
  { label: "1 hr", value: 60 },
  { label: "1 day", value: 1440 }, // 24 * 60
  { label: "2 days", value: 2880 }, // 2 * 24 * 60,
  { label: "3 days", value: 4320 }, // 3 * 24 * 60,
];

export const NOTIFICATION_TIME_OUT = 3000; // 3 seconds

export const POSITIONS_LEVEL_OPTIONS = [
  {value: "0", label: "Select/Deselect All", bold: "Select/Deselect All"},
  {value: "2", label: "Certificate III Educator", bold: ""},
  {value: "1", label: "Assistant Educator", bold: ""},
  {value: "3", label: "Diploma Educator", bold: ""},
  {value: "15", label: "Room Leader", bold: ""},  
  {value: "4", label: "Provisional Early Childhood Teacher", bold: ""},
  {value: "5", label: "Early Childhood Teacher", bold: ""},
  {value: "6", label: "Nominated Supervisor", bold: ""},
  {value: "14", label: "Assistant Centre Director", bold: ""},
  {value: "15", label: "Admin Assistant", bold: ""},
  {value: "7", label: "Cleaner", bold: ""},
  {value: "8", label: "Gardener", bold: ""},
  {value: "9", label: "Chef/Cook", bold: ""}
];

export const STAGE_1_APPROVE_VALUE = "approve_candidate_to_stage_2";
export const STAGE_1_APPROVE_COMPLIANCE_CHECK_VALUE = "approve_candidate_bypass_compliance_check";
export const STAGE_2_APPROVE_VALUE = "approve_candidate_to_stage_3";
export const STAGE_APPROVED_VALUE = "approved";
export const STAGE_DECLINED_VALUE = "declined";

export const CANDIDATE_TIMESHEET_PENDING = 1;
export const CANDIDATE_TIMESHEET_PENDING_APPROVAL = 2;
export const CANDIDATE_TIMESHEET_APPROVED = 3;
export const CANDIDATE_TIMESHEET_DECLINED = 4;

export const CANDIDATE_KEY_DOCUMENTS = [
  "australian_work_visa",
  "permanent_residency_visa",
  "working_with_children_check",
  "first_aid_certificate",
  "mandatory_reporting_training",
  "teachers_registration",
  "post_graduate_diploma",
  "bachelor_or_degree",
  "certificate_iii",
  "course_progression_letter",
  "ACECQA_assessment",
  "cooking_qualification",
  "food_handler_certificate",
  "diploma"  
  
]

 export const STATE_ALIAS: Record<string, string> = {
  "VICTORIA": "VIC",
  "NEW SOUTH WALES": "NSW",
  "QUEENSLAND": "QLD",
  "WESTERN AUSTRALIA": "WA",
  "SOUTH AUSTRALIA": "SA",
  "TASMANIA": "TAS",
  "AUSTRALIAN CAPITAL TERRITORY": "ACT",
  "NORTHERN TERRITORY": "NT",
};

export const STATE_LINKS: Record<string, string> = {
  VIC: "https://www.vic.gov.au/become-early-childhood-teacher-educator",
  NSW: "https://education.nsw.gov.au/teach-nsw/explore-teaching/types-of-teachers/early-childhood-teachers",
  QLD: "https://www.qld.gov.au/education/jobs/teacher/childhood",
  SA: "https://www.education.sa.gov.au/working-us/careers-education/teachers-and-school-and-preschool-leaders/teacher-employment-requirements-and-registration",
  WA: "https://www.education.wa.edu.au/teacher-qualifications-and-registration",
  NT: "https://education.nt.gov.au/careers-in-education/early-childhood-education-care-career-pathways",
  ACT: "https://elacca.org.au/early-childhood-training-qualifications/canberra-act/",
  TAS: "https://elacca.org.au/early-childhood-training-qualifications/hobart-tasmania/",
};

export const EMPLOYEE_PENDING_REVIEW_SORT_OPTIONS = [
  {value: "first_name-asc", label: "Employee Name", bold: "A-Z"},
  {value: "first_name-desc", label: "Employee Name", bold: "Z-A"},
  {value: "current_stage-asc", label: "Stage", bold: "1-3"},
  {value: "current_stage-desc", label: "Stage", bold: "3-1"},
  {value: "created_at-desc", label: "Date Started/Last Submitted", bold: "Recent First"},
  {value: "created_at-asc", label: "Date Started/Last Submitted", bold: "Oldest First"},
];

export const ELV_CENTRE_TERMS_DOCUMENTS = {
  staffCode: "https://crew-connect-dev-bucket.s3.us-west-2.amazonaws.com/CasualAndFairWorkPdf/ELV+Staff+Induction+1.pdf",
  childSafetyCode: "https://crew-connect-dev-bucket.s3.us-west-2.amazonaws.com/CasualAndFairWorkPdf/Child+Safety+Code+of+Conduct+ELV+Policy.pdf",
  elvStaffInduction: "https://crew-connect-dev-bucket.s3.us-west-2.amazonaws.com/CasualAndFairWorkPdf/Staff+Code+of+Conduct+ELV+Policy+1.pdf",

};

export const CANDIDATE_LEVEL_ORDER = {
  "Certificate III Educator": 1,
  "Assistant Educator": 2,
  "Diploma Educator": 3,
  "Room Leader": 4,
  "Provisional Early Childhood Teacher": 5,
  "Early Childhood Teacher": 6,
  "Nominated Supervisor": 7,
  "Assistant Centre Director": 8,
} 